import { Immutable } from "immer";
import React from "react";
import { RawHTMLBlock } from "tsi-common-react/src/components/RawHTMLBlock/index";

import { templates } from "@reactivated";
import type { RawHTMLBlock as RawHTMLBlockValue } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { HeroBlockA } from "../../blocks/HeroBlockA";
import { HeroBlockB } from "../../blocks/HeroBlockB";

/**
 * Component map for the pillows HomePage hero-options assembly. Exported so
 * the block-screenshot styleguide harness renders through the same map
 * production uses (see ``StyleguideBlockTemplate.tsx``).
 */
export const homePageHeroOptionsComponentsMap = {
    raw_html: (block: { value: Immutable<RawHTMLBlockValue> }) => (
        <RawHTMLBlock value={block.value} />
    ),
    homepage_hero_a: HeroBlockA,
    homepage_hero_b: HeroBlockB,
} as const;

/**
 * Pillows HomePage hero-options assembly: dispatches the
 * ``HomePageHeroOptionsBlock`` StreamField (raw HTML + A/B hero variants) to
 * its React components, replacing the legacy ``{{ self.hero_options }}``
 * hydration root.
 */
export const HomePageHeroOptions = (
    props: Immutable<{ page: templates.HomePageTemplate["page"] }>,
): React.JSX.Element | null => {
    if (!props.page.hero_options) {
        return null;
    }
    return (
        <StreamField
            tagName={React.Fragment}
            value={props.page.hero_options.value}
            components={homePageHeroOptionsComponentsMap}
        />
    );
};
